import React from "react";

/**
 * @component PersonCircleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <PersonCircleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonCircleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PersonCircleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2l.28.004.316.013.244.018.402.041.14.019.267.04.162.029.19.036a10.01 10.01 0 017.864 8.151L21.8 10l.046.244.056.352.031.244.017.154.022.257.02.367c.006.127.008.254.008.382l-.002.207-.01.299-.022.323-.04.397-.032.238-.059.354-.062.308-.05.22-.046.184a9.93 9.93 0 01-.12.422l-.092.283-.13.357-.113.283-.094.215-.161.341-.136.265-.178.32-.13.217c-.145.237-.302.47-.47.696l-.274.356-.229.273-.14.157-.258.274-.226.224-.104.099-.238.215-.312.262-.398.305-.284.199-.33.213a9.99 9.99 0 01-.35.208l-.266.145-.383.19-.291.132-.346.142-.358.132-.31.1-.402.116-.138.035-.187.045-.347.072-.443.074-.305.04-.16.016-.423.032-.271.011L12 22l-.2-.002-.331-.012-.373-.026-.167-.017-.164-.019-.246-.033-.336-.056-.3-.06-.31-.072-.415-.113-.297-.093-.323-.112-.284-.11-.343-.147-.266-.124-.28-.14-.159-.086-.328-.188-.177-.108-.297-.193-.383-.272-.316-.247-.316-.267-.333-.307-.208-.207-.247-.262-.17-.192-.245-.294-.18-.233a10.017 10.017 0 01-.361-.511l-.171-.27-.063-.103-.1-.17-.142-.259-.198-.392-.1-.213-.126-.295-.11-.281a9.91 9.91 0 01-.312-.984l-.096-.403-.062-.309-.059-.354-.06-.49-.028-.376-.013-.278A10.18 10.18 0 012 12C2 6.477 6.477 2 12 2zm0 16c-1.157 0-2.315.119-3.476.357a1.998 1.998 0 00-.831.385c.264.17.538.323.822.46l.287.133.295.122.356.13.292.09.146.042.27.068.248.055.281.051c.108.018.216.034.325.047l.38.037.28.017L12 20l.368-.008.167-.01.167-.012c.12-.01.24-.024.36-.04l.289-.044.24-.044.248-.054.313-.08.16-.047.234-.075.3-.107.395-.163.247-.114.304-.156.214-.12a8 8 0 00.3-.183 1.984 1.984 0 00-.83-.386A17.249 17.249 0 0012 18zm0-14a8 8 0 00-8 8l.008.352.014.24.025.28.024.196.04.265.043.236.063.29.046.184.083.29.034.11.113.329.17.42.07.158c.09.193.186.382.29.567l.202.34.126.194.241.34.18.23.134.162.235.264a3.988 3.988 0 011.981-1.05A19.248 19.248 0 0112 16c1.292 0 2.585.133 3.877.398.76.156 1.444.525 1.983 1.048l.236-.265.193-.236.125-.163.18-.25.17-.258.097-.157.094-.16.14-.257.131-.263.103-.225.133-.321.119-.328.098-.313.104-.39.063-.291.053-.297c.02-.12.036-.242.05-.365l.03-.32.01-.181c.008-.135.011-.27.011-.406l-.012-.443a8.034 8.034 0 00-.078-.762l-.081-.449a8.012 8.012 0 00-5.843-6.097l-.422-.096-.353-.062-.358-.046a8.054 8.054 0 00-.409-.033l.359.028-.213-.019-.214-.012L12 4zm0 3a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
        fillRule="evenodd"
      />
    </svg>
  )
);
PersonCircleIcon.displayName = "PersonCircleIcon";
export default PersonCircleIcon;
